import type { Modifier } from "@dnd-kit/core";

/**
 * Positions the drag overlay so its center tracks the cursor, independent
 * of the source element's size and grab offset. Using this modifier lets a
 * small pill follow the pointer exactly whether the source was a full-width
 * row or a grid card.
 */
export const snapCenterToCursor: Modifier = ({
  activatorEvent,
  draggingNodeRect,
  transform,
}) => {
  if (!draggingNodeRect || !activatorEvent) return transform;

  const event = activatorEvent as PointerEvent | MouseEvent;
  const clientX =
    typeof (event as PointerEvent).clientX === "number"
      ? (event as PointerEvent).clientX
      : null;
  const clientY =
    typeof (event as PointerEvent).clientY === "number"
      ? (event as PointerEvent).clientY
      : null;
  if (clientX == null || clientY == null) return transform;

  const offsetX = clientX - draggingNodeRect.left - draggingNodeRect.width / 2;
  const offsetY = clientY - draggingNodeRect.top - draggingNodeRect.height / 2;

  return {
    ...transform,
    x: transform.x + offsetX,
    y: transform.y + offsetY,
  };
};
